import React from 'react';
import {CheckboxMenuItem} from 'epic-ue-ui';
import {Counts} from '../jobs.fetch';

interface Props {
    toggleCheckboxFilter: (e: any, filterName: string, value: string) => void;
    jobsFilters?: any;
    counts?: Counts;
    remoteLabel?: string;
}

export const RemoteEligible = ({
    toggleCheckboxFilter,
    jobsFilters,
    counts,
    remoteLabel
}: Props): JSX.Element => {
    const checked = jobsFilters?.remote?.includes('true') || false;
    let disabled = false;
    if (counts?.remote?.[1] === 0) {
        disabled = true;
    }
    return (
        <ul className="remote-eligible-checkbox">
            <CheckboxMenuItem
                checkboxProps={{
                    checked,
                    disabled
                }}
                onClick={(e) => !disabled && toggleCheckboxFilter(e, 'remote', 'true')}>
                {remoteLabel || 'Remote Eligible'}
            </CheckboxMenuItem>
        </ul>
    );
};
